/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { CustomerApplication } from '../models/customer-application';
import { SmartIrrigationModel } from '../models/smart-irrigation-model';
import { SmartIrrigationDashboard } from '../models/smart-irrigation-dashboard';
import { SmartIrrigationAlarm } from '../models/smart-irrigation-alarm';
import { ManualSmartIrrigationSchedule } from '../models/manual-smart-irrigation-schedule';
import { AutomatedSmartIrrigationSchedule } from '../models/automated-smart-irrigation-schedule';
import { WeeklySmartIrrigationSchedule } from '../models/weekly-smart-irrigation-schedule';
import { SmartIrrigationNodeDto } from '../models/smart-irrigation-node-dto';
import { SmartIrrigationRootNodeDto } from '../models/smart-irrigation-root-node-dto';
import { SmartIrrigationNodeCreateDto } from '../models/smart-irrigation-node-create-dto';
import { SmartIrrigationNodeUpdateDto } from '../models/smart-irrigation-node-update-dto';
import { SmartIrrigationNodeUserDto } from '../models/smart-irrigation-node-user-dto';
import { SmartIrrigationNodeUserCreateDto } from '../models/smart-irrigation-node-user-create-dto';
import { SmartIrrigationNodeUserUpdateDto } from '../models/smart-irrigation-node-user-update-dto';
import { SmartIrrigationRoleDto } from '../models/smart-irrigation-role-dto';
import { SmartIrrigationDeviceDto } from '../models/smart-irrigation-device-dto';
import { SmartIrrigationDeviceCreateDto } from '../models/smart-irrigation-device-create-dto';
import { SmartIrrigationDeviceUpdateDto } from '../models/smart-irrigation-device-update-dto';
import { SmartIrrigationDeviceLinkDto } from '../models/smart-irrigation-device-link-dto';
import { SmartIrrigationDeviceTypeDto } from '../models/smart-irrigation-device-type-dto';
import { User } from '../models/user';
@Injectable({
  providedIn: 'root',
})
class SmartIrrigationService extends __BaseService {
  static readonly SmartIrrigationGetPath = '/api/SmartIrrigation/Get';
  static readonly SmartIrrigationPurchasePath = '/api/SmartIrrigation/Purchase';
  static readonly SmartIrrigationGetModelPath = '/api/SmartIrrigation/GetModel/{customerId}';
  static readonly SmartIrrigationGetDashboardPath = '/api/SmartIrrigation/GetDashboard/{customerId}';
  static readonly SmartIrrigationGetAlarmsPath = '/api/SmartIrrigation/GetAlarms/{customerId}';
  static readonly SmartIrrigationSnoozeAlarmPath = '/api/SmartIrrigation/SnoozeAlarm/{customerId}/{alarmId}';
  static readonly SmartIrrigationGetSchedulesPath = '/api/SmartIrrigation/GetSchedules/{customerId}';
  static readonly SmartIrrigationGetAutomatedSchedulesPath = '/api/SmartIrrigation/GetAutomatedSchedules/{customerId}';
  static readonly SmartIrrigationGetAutomatedSchedulePath = '/api/SmartIrrigation/GetAutomatedSchedule/{customerId}/{deviceEui}';
  static readonly SmartIrrigationClearAutomatedSchedulePath = '/api/SmartIrrigation/ClearAutomatedSchedule/{customerId}/{deviceEui}';
  static readonly SmartIrrigationAddWeeklySchedulePath = '/api/SmartIrrigation/AddWeeklySchedule/{customerId}';
  static readonly SmartIrrigationUpdateWeeklySchedulePath = '/api/SmartIrrigation/UpdateWeeklySchedule/{customerId}';
  static readonly SmartIrrigationAddManualSchedulePath = '/api/SmartIrrigation/AddManualSchedule/{customerId}';
  static readonly SmartIrrigationUpdateManualSchedulePath = '/api/SmartIrrigation/UpdateManualSchedule/{customerId}';
  static readonly SmartIrrigationAddAutomatedSchedulePath = '/api/SmartIrrigation/AddAutomatedSchedule/{customerId}';
  static readonly SmartIrrigationUpdateAutomatedSchedulePath = '/api/SmartIrrigation/UpdateAutomatedSchedule/{customerId}';
  static readonly SmartIrrigationDeleteSchedulePath = '/api/SmartIrrigation/DeleteSechedule/{customerId}/{scheduleId}';
  static readonly SmartIrrigationGetNodesPath = '/api/SmartIrrigation/GetNodes/{customerId}';
  static readonly SmartIrrigationGetRootNodePath = '/api/SmartIrrigation/GetRootNode/{customerId}';
  static readonly SmartIrrigationGetNodePath = '/api/SmartIrrigation/GetRootNode/{customerId}/{nodeId}';
  static readonly SmartIrrigationAddNodePath = '/api/SmartIrrigation/AddNode/{customerId}';
  static readonly SmartIrrigationUpdateNodePath = '/api/SmartIrrigation/UpdateNode/{customerId}';
  static readonly SmartIrrigationDeleteNodePath = '/api/SmartIrrigation/DeleteNode/{customerId}/{nodeId}';
  static readonly SmartIrrigationGetNodeUsersPath = '/api/SmartIrrigation/GetNodeUsers/{customerId}/{nodeId}';
  static readonly SmartIrrigationAddNodeUserPath = '/api/SmartIrrigation/AddNodeUser/{customerId}';
  static readonly SmartIrrigationUpdateNodeUserPath = '/api/SmartIrrigation/UpdateNodeUser/{customerId}';
  static readonly SmartIrrigationDeleteNodeUserPath = '/api/SmartIrrigation/DeleteNodeUser/{customerId}/{nodeUserId}';
  static readonly SmartIrrigationGetNodeRolesPath = '/api/SmartIrrigation/GetNodeRoles';
  static readonly SmartIrrigationGetDevicesPath = '/api/SmartIrrigation/GetDevices/{customerId}';
  static readonly SmartIrrigationGetUnlinkedDevicesPath = '/api/SmartIrrigation/GetUnlinkedDevices/{customerId}';
  static readonly SmartIrrigationGetNodeDevicesPath = '/api/SmartIrrigation/GetNodeDevices/{customerId}/{nodeId}';
  static readonly SmartIrrigationAddNodeDevicePath = '/api/SmartIrrigation/AddNodeDevice/{customerId}';
  static readonly SmartIrrigationUpdateNodeDevicePath = '/api/SmartIrrigation/UpdateNodeDevice/{customerId}';
  static readonly SmartIrrigationLinkDeviceToNodePath = '/api/SmartIrrigation/LinkDeviceToNode/{customerId}';
  static readonly SmartIrrigationDeleteNodeDevicePath = '/api/SmartIrrigation/DeleteNodeDevice/{customerId}/{deviceId}';
  static readonly SmartIrrigationGetDeviceTypesPath = '/api/SmartIrrigation/GetDeviceTypes';
  static readonly SmartIrrigationGetAssociatableUsersPath = '/api/SmartIrrigation/GetAssociatableUsers/{customerId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetResponse(customerId?: number): __Observable<__StrictHttpResponse<CustomerApplication>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/Get`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerApplication>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGet(customerId?: number): __Observable<CustomerApplication> {
    return this.SmartIrrigationGetResponse(customerId).pipe(
      __map(_r => _r.body as CustomerApplication)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationPurchaseResponse(customerId?: number): __Observable<__StrictHttpResponse<CustomerApplication>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/Purchase`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerApplication>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationPurchase(customerId?: number): __Observable<CustomerApplication> {
    return this.SmartIrrigationPurchaseResponse(customerId).pipe(
      __map(_r => _r.body as CustomerApplication)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetModelResponse(customerId: number): __Observable<__StrictHttpResponse<SmartIrrigationModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetModel/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationModel>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetModel(customerId: number): __Observable<SmartIrrigationModel> {
    return this.SmartIrrigationGetModelResponse(customerId).pipe(
      __map(_r => _r.body as SmartIrrigationModel)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetDashboardResponse(customerId: number): __Observable<__StrictHttpResponse<SmartIrrigationDashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetDashboard/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationDashboard>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetDashboard(customerId: number): __Observable<SmartIrrigationDashboard> {
    return this.SmartIrrigationGetDashboardResponse(customerId).pipe(
      __map(_r => _r.body as SmartIrrigationDashboard)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetAlarmsResponse(customerId: number): __Observable<__StrictHttpResponse<Array<SmartIrrigationAlarm>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetAlarms/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationAlarm>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetAlarms(customerId: number): __Observable<Array<SmartIrrigationAlarm>> {
    return this.SmartIrrigationGetAlarmsResponse(customerId).pipe(
      __map(_r => _r.body as Array<SmartIrrigationAlarm>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationSnoozeAlarmParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `alarmId`:
   */
  SmartIrrigationSnoozeAlarmResponse(params: SmartIrrigationService.SmartIrrigationSnoozeAlarmParams): __Observable<__StrictHttpResponse<Array<SmartIrrigationAlarm>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/SnoozeAlarm/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.alarmId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationAlarm>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationSnoozeAlarmParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `alarmId`:
   */
  SmartIrrigationSnoozeAlarm(params: SmartIrrigationService.SmartIrrigationSnoozeAlarmParams): __Observable<Array<SmartIrrigationAlarm>> {
    return this.SmartIrrigationSnoozeAlarmResponse(params).pipe(
      __map(_r => _r.body as Array<SmartIrrigationAlarm>)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetSchedulesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<ManualSmartIrrigationSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetSchedules/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ManualSmartIrrigationSchedule>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetSchedules(customerId: number): __Observable<Array<ManualSmartIrrigationSchedule>> {
    return this.SmartIrrigationGetSchedulesResponse(customerId).pipe(
      __map(_r => _r.body as Array<ManualSmartIrrigationSchedule>)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetAutomatedSchedulesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<AutomatedSmartIrrigationSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetAutomatedSchedules/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AutomatedSmartIrrigationSchedule>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetAutomatedSchedules(customerId: number): __Observable<Array<AutomatedSmartIrrigationSchedule>> {
    return this.SmartIrrigationGetAutomatedSchedulesResponse(customerId).pipe(
      __map(_r => _r.body as Array<AutomatedSmartIrrigationSchedule>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationGetAutomatedScheduleParams` containing the following parameters:
   *
   * - `deviceEui`:
   *
   * - `customerId`:
   */
  SmartIrrigationGetAutomatedScheduleResponse(params: SmartIrrigationService.SmartIrrigationGetAutomatedScheduleParams): __Observable<__StrictHttpResponse<Array<AutomatedSmartIrrigationSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetAutomatedSchedule/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.deviceEui))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AutomatedSmartIrrigationSchedule>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationGetAutomatedScheduleParams` containing the following parameters:
   *
   * - `deviceEui`:
   *
   * - `customerId`:
   */
  SmartIrrigationGetAutomatedSchedule(params: SmartIrrigationService.SmartIrrigationGetAutomatedScheduleParams): __Observable<Array<AutomatedSmartIrrigationSchedule>> {
    return this.SmartIrrigationGetAutomatedScheduleResponse(params).pipe(
      __map(_r => _r.body as Array<AutomatedSmartIrrigationSchedule>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationClearAutomatedScheduleParams` containing the following parameters:
   *
   * - `deviceEui`:
   *
   * - `customerId`:
   */
  SmartIrrigationClearAutomatedScheduleResponse(params: SmartIrrigationService.SmartIrrigationClearAutomatedScheduleParams): __Observable<__StrictHttpResponse<Array<AutomatedSmartIrrigationSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/ClearAutomatedSchedule/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.deviceEui))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AutomatedSmartIrrigationSchedule>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationClearAutomatedScheduleParams` containing the following parameters:
   *
   * - `deviceEui`:
   *
   * - `customerId`:
   */
  SmartIrrigationClearAutomatedSchedule(params: SmartIrrigationService.SmartIrrigationClearAutomatedScheduleParams): __Observable<Array<AutomatedSmartIrrigationSchedule>> {
    return this.SmartIrrigationClearAutomatedScheduleResponse(params).pipe(
      __map(_r => _r.body as Array<AutomatedSmartIrrigationSchedule>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddWeeklyScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `Name`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `DayOfWeek`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationAddWeeklyScheduleResponse(params: SmartIrrigationService.SmartIrrigationAddWeeklyScheduleParams): __Observable<__StrictHttpResponse<Array<WeeklySmartIrrigationSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Type != null) __params = __params.set('Type', params.Type.toString());
    if (params.StartTime != null) __params = __params.set('StartTime', params.StartTime.toString());
    if (params.Name != null) __params = __params.set('Name', params.Name.toString());
    if (params.Id != null) __params = __params.set('Id', params.Id.toString());
    if (params.EndTime != null) __params = __params.set('EndTime', params.EndTime.toString());
    if (params.Enabled != null) __params = __params.set('Enabled', params.Enabled.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.DayOfWeek != null) __params = __params.set('DayOfWeek', params.DayOfWeek.toString());
    if (params.ControllerDeviceEui != null) __params = __params.set('ControllerDeviceEui', params.ControllerDeviceEui.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/AddWeeklySchedule/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<WeeklySmartIrrigationSchedule>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddWeeklyScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `Name`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `DayOfWeek`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationAddWeeklySchedule(params: SmartIrrigationService.SmartIrrigationAddWeeklyScheduleParams): __Observable<Array<WeeklySmartIrrigationSchedule>> {
    return this.SmartIrrigationAddWeeklyScheduleResponse(params).pipe(
      __map(_r => _r.body as Array<WeeklySmartIrrigationSchedule>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateWeeklyScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `Name`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `DayOfWeek`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationUpdateWeeklyScheduleResponse(params: SmartIrrigationService.SmartIrrigationUpdateWeeklyScheduleParams): __Observable<__StrictHttpResponse<Array<WeeklySmartIrrigationSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Type != null) __params = __params.set('Type', params.Type.toString());
    if (params.StartTime != null) __params = __params.set('StartTime', params.StartTime.toString());
    if (params.Name != null) __params = __params.set('Name', params.Name.toString());
    if (params.Id != null) __params = __params.set('Id', params.Id.toString());
    if (params.EndTime != null) __params = __params.set('EndTime', params.EndTime.toString());
    if (params.Enabled != null) __params = __params.set('Enabled', params.Enabled.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.DayOfWeek != null) __params = __params.set('DayOfWeek', params.DayOfWeek.toString());
    if (params.ControllerDeviceEui != null) __params = __params.set('ControllerDeviceEui', params.ControllerDeviceEui.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SmartIrrigation/UpdateWeeklySchedule/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<WeeklySmartIrrigationSchedule>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateWeeklyScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `Name`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `DayOfWeek`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationUpdateWeeklySchedule(params: SmartIrrigationService.SmartIrrigationUpdateWeeklyScheduleParams): __Observable<Array<WeeklySmartIrrigationSchedule>> {
    return this.SmartIrrigationUpdateWeeklyScheduleResponse(params).pipe(
      __map(_r => _r.body as Array<WeeklySmartIrrigationSchedule>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddManualScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `timeZoneOffsetMinutes`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `Name`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationAddManualScheduleResponse(params: SmartIrrigationService.SmartIrrigationAddManualScheduleParams): __Observable<__StrictHttpResponse<Array<WeeklySmartIrrigationSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.timeZoneOffsetMinutes != null) __params = __params.set('timeZoneOffsetMinutes', params.timeZoneOffsetMinutes.toString());
    if (params.Type != null) __params = __params.set('Type', params.Type.toString());
    if (params.StartTime != null) __params = __params.set('StartTime', params.StartTime.toString());
    if (params.Name != null) __params = __params.set('Name', params.Name.toString());
    if (params.Id != null) __params = __params.set('Id', params.Id.toString());
    if (params.EndTime != null) __params = __params.set('EndTime', params.EndTime.toString());
    if (params.Enabled != null) __params = __params.set('Enabled', params.Enabled.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.ControllerDeviceEui != null) __params = __params.set('ControllerDeviceEui', params.ControllerDeviceEui.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/AddManualSchedule/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<WeeklySmartIrrigationSchedule>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddManualScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `timeZoneOffsetMinutes`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `Name`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationAddManualSchedule(params: SmartIrrigationService.SmartIrrigationAddManualScheduleParams): __Observable<Array<WeeklySmartIrrigationSchedule>> {
    return this.SmartIrrigationAddManualScheduleResponse(params).pipe(
      __map(_r => _r.body as Array<WeeklySmartIrrigationSchedule>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateManualScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `Name`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationUpdateManualScheduleResponse(params: SmartIrrigationService.SmartIrrigationUpdateManualScheduleParams): __Observable<__StrictHttpResponse<Array<ManualSmartIrrigationSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Type != null) __params = __params.set('Type', params.Type.toString());
    if (params.StartTime != null) __params = __params.set('StartTime', params.StartTime.toString());
    if (params.Name != null) __params = __params.set('Name', params.Name.toString());
    if (params.Id != null) __params = __params.set('Id', params.Id.toString());
    if (params.EndTime != null) __params = __params.set('EndTime', params.EndTime.toString());
    if (params.Enabled != null) __params = __params.set('Enabled', params.Enabled.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.ControllerDeviceEui != null) __params = __params.set('ControllerDeviceEui', params.ControllerDeviceEui.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SmartIrrigation/UpdateManualSchedule/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ManualSmartIrrigationSchedule>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateManualScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `Name`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationUpdateManualSchedule(params: SmartIrrigationService.SmartIrrigationUpdateManualScheduleParams): __Observable<Array<ManualSmartIrrigationSchedule>> {
    return this.SmartIrrigationUpdateManualScheduleResponse(params).pipe(
      __map(_r => _r.body as Array<ManualSmartIrrigationSchedule>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddAutomatedScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `SoilMoistureProbeDeviceEui`:
   *
   * - `Name`:
   *
   * - `IrrigationCutoff`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `DayOfWeek`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationAddAutomatedScheduleResponse(params: SmartIrrigationService.SmartIrrigationAddAutomatedScheduleParams): __Observable<__StrictHttpResponse<AutomatedSmartIrrigationSchedule>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Type != null) __params = __params.set('Type', params.Type.toString());
    if (params.StartTime != null) __params = __params.set('StartTime', params.StartTime.toString());
    if (params.SoilMoistureProbeDeviceEui != null) __params = __params.set('SoilMoistureProbeDeviceEui', params.SoilMoistureProbeDeviceEui.toString());
    if (params.Name != null) __params = __params.set('Name', params.Name.toString());
    if (params.IrrigationCutoff != null) __params = __params.set('IrrigationCutoff', params.IrrigationCutoff.toString());
    if (params.Id != null) __params = __params.set('Id', params.Id.toString());
    if (params.EndTime != null) __params = __params.set('EndTime', params.EndTime.toString());
    if (params.Enabled != null) __params = __params.set('Enabled', params.Enabled.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.DayOfWeek != null) __params = __params.set('DayOfWeek', params.DayOfWeek.toString());
    if (params.ControllerDeviceEui != null) __params = __params.set('ControllerDeviceEui', params.ControllerDeviceEui.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/AddAutomatedSchedule/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AutomatedSmartIrrigationSchedule>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddAutomatedScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `SoilMoistureProbeDeviceEui`:
   *
   * - `Name`:
   *
   * - `IrrigationCutoff`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `DayOfWeek`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationAddAutomatedSchedule(params: SmartIrrigationService.SmartIrrigationAddAutomatedScheduleParams): __Observable<AutomatedSmartIrrigationSchedule> {
    return this.SmartIrrigationAddAutomatedScheduleResponse(params).pipe(
      __map(_r => _r.body as AutomatedSmartIrrigationSchedule)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateAutomatedScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `SoilMoistureProbeDeviceEui`:
   *
   * - `Name`:
   *
   * - `IrrigationCutoff`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `DayOfWeek`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationUpdateAutomatedScheduleResponse(params: SmartIrrigationService.SmartIrrigationUpdateAutomatedScheduleParams): __Observable<__StrictHttpResponse<AutomatedSmartIrrigationSchedule>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Type != null) __params = __params.set('Type', params.Type.toString());
    if (params.StartTime != null) __params = __params.set('StartTime', params.StartTime.toString());
    if (params.SoilMoistureProbeDeviceEui != null) __params = __params.set('SoilMoistureProbeDeviceEui', params.SoilMoistureProbeDeviceEui.toString());
    if (params.Name != null) __params = __params.set('Name', params.Name.toString());
    if (params.IrrigationCutoff != null) __params = __params.set('IrrigationCutoff', params.IrrigationCutoff.toString());
    if (params.Id != null) __params = __params.set('Id', params.Id.toString());
    if (params.EndTime != null) __params = __params.set('EndTime', params.EndTime.toString());
    if (params.Enabled != null) __params = __params.set('Enabled', params.Enabled.toString());
    if (params.Description != null) __params = __params.set('Description', params.Description.toString());
    if (params.DayOfWeek != null) __params = __params.set('DayOfWeek', params.DayOfWeek.toString());
    if (params.ControllerDeviceEui != null) __params = __params.set('ControllerDeviceEui', params.ControllerDeviceEui.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SmartIrrigation/UpdateAutomatedSchedule/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AutomatedSmartIrrigationSchedule>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateAutomatedScheduleParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `Type`:
   *
   * - `StartTime`:
   *
   * - `SoilMoistureProbeDeviceEui`:
   *
   * - `Name`:
   *
   * - `IrrigationCutoff`:
   *
   * - `Id`:
   *
   * - `EndTime`:
   *
   * - `Enabled`:
   *
   * - `Description`:
   *
   * - `DayOfWeek`:
   *
   * - `ControllerDeviceEui`:
   */
  SmartIrrigationUpdateAutomatedSchedule(params: SmartIrrigationService.SmartIrrigationUpdateAutomatedScheduleParams): __Observable<AutomatedSmartIrrigationSchedule> {
    return this.SmartIrrigationUpdateAutomatedScheduleResponse(params).pipe(
      __map(_r => _r.body as AutomatedSmartIrrigationSchedule)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationDeleteScheduleParams` containing the following parameters:
   *
   * - `scheduleId`:
   *
   * - `customerId`:
   */
  SmartIrrigationDeleteScheduleResponse(params: SmartIrrigationService.SmartIrrigationDeleteScheduleParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/SmartIrrigation/DeleteSechedule/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.scheduleId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationDeleteScheduleParams` containing the following parameters:
   *
   * - `scheduleId`:
   *
   * - `customerId`:
   */
  SmartIrrigationDeleteSchedule(params: SmartIrrigationService.SmartIrrigationDeleteScheduleParams): __Observable<Blob> {
    return this.SmartIrrigationDeleteScheduleResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetNodesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<SmartIrrigationNodeDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetNodes/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationNodeDto>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetNodes(customerId: number): __Observable<Array<SmartIrrigationNodeDto>> {
    return this.SmartIrrigationGetNodesResponse(customerId).pipe(
      __map(_r => _r.body as Array<SmartIrrigationNodeDto>)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetRootNodeResponse(customerId: number): __Observable<__StrictHttpResponse<SmartIrrigationRootNodeDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetRootNode/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationRootNodeDto>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetRootNode(customerId: number): __Observable<SmartIrrigationRootNodeDto> {
    return this.SmartIrrigationGetRootNodeResponse(customerId).pipe(
      __map(_r => _r.body as SmartIrrigationRootNodeDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationGetNodeParams` containing the following parameters:
   *
   * - `nodeId`:
   *
   * - `customerId`:
   */
  SmartIrrigationGetNodeResponse(params: SmartIrrigationService.SmartIrrigationGetNodeParams): __Observable<__StrictHttpResponse<SmartIrrigationRootNodeDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetRootNode/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.nodeId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationRootNodeDto>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationGetNodeParams` containing the following parameters:
   *
   * - `nodeId`:
   *
   * - `customerId`:
   */
  SmartIrrigationGetNode(params: SmartIrrigationService.SmartIrrigationGetNodeParams): __Observable<SmartIrrigationRootNodeDto> {
    return this.SmartIrrigationGetNodeResponse(params).pipe(
      __map(_r => _r.body as SmartIrrigationRootNodeDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddNodeParams` containing the following parameters:
   *
   * - `node`:
   *
   * - `customerId`:
   */
  SmartIrrigationAddNodeResponse(params: SmartIrrigationService.SmartIrrigationAddNodeParams): __Observable<__StrictHttpResponse<SmartIrrigationNodeDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.node;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/AddNode/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationNodeDto>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddNodeParams` containing the following parameters:
   *
   * - `node`:
   *
   * - `customerId`:
   */
  SmartIrrigationAddNode(params: SmartIrrigationService.SmartIrrigationAddNodeParams): __Observable<SmartIrrigationNodeDto> {
    return this.SmartIrrigationAddNodeResponse(params).pipe(
      __map(_r => _r.body as SmartIrrigationNodeDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateNodeParams` containing the following parameters:
   *
   * - `node`:
   *
   * - `customerId`:
   */
  SmartIrrigationUpdateNodeResponse(params: SmartIrrigationService.SmartIrrigationUpdateNodeParams): __Observable<__StrictHttpResponse<SmartIrrigationNodeDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.node;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SmartIrrigation/UpdateNode/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationNodeDto>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateNodeParams` containing the following parameters:
   *
   * - `node`:
   *
   * - `customerId`:
   */
  SmartIrrigationUpdateNode(params: SmartIrrigationService.SmartIrrigationUpdateNodeParams): __Observable<SmartIrrigationNodeDto> {
    return this.SmartIrrigationUpdateNodeResponse(params).pipe(
      __map(_r => _r.body as SmartIrrigationNodeDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationDeleteNodeParams` containing the following parameters:
   *
   * - `nodeId`:
   *
   * - `customerId`:
   */
  SmartIrrigationDeleteNodeResponse(params: SmartIrrigationService.SmartIrrigationDeleteNodeParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/SmartIrrigation/DeleteNode/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.nodeId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationDeleteNodeParams` containing the following parameters:
   *
   * - `nodeId`:
   *
   * - `customerId`:
   */
  SmartIrrigationDeleteNode(params: SmartIrrigationService.SmartIrrigationDeleteNodeParams): __Observable<Blob> {
    return this.SmartIrrigationDeleteNodeResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationGetNodeUsersParams` containing the following parameters:
   *
   * - `nodeId`:
   *
   * - `customerId`:
   */
  SmartIrrigationGetNodeUsersResponse(params: SmartIrrigationService.SmartIrrigationGetNodeUsersParams): __Observable<__StrictHttpResponse<Array<SmartIrrigationNodeUserDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetNodeUsers/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.nodeId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationNodeUserDto>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationGetNodeUsersParams` containing the following parameters:
   *
   * - `nodeId`:
   *
   * - `customerId`:
   */
  SmartIrrigationGetNodeUsers(params: SmartIrrigationService.SmartIrrigationGetNodeUsersParams): __Observable<Array<SmartIrrigationNodeUserDto>> {
    return this.SmartIrrigationGetNodeUsersResponse(params).pipe(
      __map(_r => _r.body as Array<SmartIrrigationNodeUserDto>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddNodeUserParams` containing the following parameters:
   *
   * - `nodeUser`:
   *
   * - `customerId`:
   */
  SmartIrrigationAddNodeUserResponse(params: SmartIrrigationService.SmartIrrigationAddNodeUserParams): __Observable<__StrictHttpResponse<SmartIrrigationNodeUserDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.nodeUser;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/AddNodeUser/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationNodeUserDto>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddNodeUserParams` containing the following parameters:
   *
   * - `nodeUser`:
   *
   * - `customerId`:
   */
  SmartIrrigationAddNodeUser(params: SmartIrrigationService.SmartIrrigationAddNodeUserParams): __Observable<SmartIrrigationNodeUserDto> {
    return this.SmartIrrigationAddNodeUserResponse(params).pipe(
      __map(_r => _r.body as SmartIrrigationNodeUserDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateNodeUserParams` containing the following parameters:
   *
   * - `nodeUser`:
   *
   * - `customerId`:
   */
  SmartIrrigationUpdateNodeUserResponse(params: SmartIrrigationService.SmartIrrigationUpdateNodeUserParams): __Observable<__StrictHttpResponse<SmartIrrigationNodeUserDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.nodeUser;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SmartIrrigation/UpdateNodeUser/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationNodeUserDto>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateNodeUserParams` containing the following parameters:
   *
   * - `nodeUser`:
   *
   * - `customerId`:
   */
  SmartIrrigationUpdateNodeUser(params: SmartIrrigationService.SmartIrrigationUpdateNodeUserParams): __Observable<SmartIrrigationNodeUserDto> {
    return this.SmartIrrigationUpdateNodeUserResponse(params).pipe(
      __map(_r => _r.body as SmartIrrigationNodeUserDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationDeleteNodeUserParams` containing the following parameters:
   *
   * - `nodeUserId`:
   *
   * - `customerId`:
   */
  SmartIrrigationDeleteNodeUserResponse(params: SmartIrrigationService.SmartIrrigationDeleteNodeUserParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/SmartIrrigation/DeleteNodeUser/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.nodeUserId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationDeleteNodeUserParams` containing the following parameters:
   *
   * - `nodeUserId`:
   *
   * - `customerId`:
   */
  SmartIrrigationDeleteNodeUser(params: SmartIrrigationService.SmartIrrigationDeleteNodeUserParams): __Observable<Blob> {
    return this.SmartIrrigationDeleteNodeUserResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  SmartIrrigationGetNodeRolesResponse(): __Observable<__StrictHttpResponse<Array<SmartIrrigationRoleDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetNodeRoles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationRoleDto>>;
      })
    );
  }  SmartIrrigationGetNodeRoles(): __Observable<Array<SmartIrrigationRoleDto>> {
    return this.SmartIrrigationGetNodeRolesResponse().pipe(
      __map(_r => _r.body as Array<SmartIrrigationRoleDto>)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetDevicesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<SmartIrrigationDeviceDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetDevices/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationDeviceDto>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetDevices(customerId: number): __Observable<Array<SmartIrrigationDeviceDto>> {
    return this.SmartIrrigationGetDevicesResponse(customerId).pipe(
      __map(_r => _r.body as Array<SmartIrrigationDeviceDto>)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetUnlinkedDevicesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<SmartIrrigationDeviceDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetUnlinkedDevices/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationDeviceDto>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetUnlinkedDevices(customerId: number): __Observable<Array<SmartIrrigationDeviceDto>> {
    return this.SmartIrrigationGetUnlinkedDevicesResponse(customerId).pipe(
      __map(_r => _r.body as Array<SmartIrrigationDeviceDto>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationGetNodeDevicesParams` containing the following parameters:
   *
   * - `nodeId`:
   *
   * - `customerId`:
   */
  SmartIrrigationGetNodeDevicesResponse(params: SmartIrrigationService.SmartIrrigationGetNodeDevicesParams): __Observable<__StrictHttpResponse<Array<SmartIrrigationDeviceDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetNodeDevices/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.nodeId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationDeviceDto>>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationGetNodeDevicesParams` containing the following parameters:
   *
   * - `nodeId`:
   *
   * - `customerId`:
   */
  SmartIrrigationGetNodeDevices(params: SmartIrrigationService.SmartIrrigationGetNodeDevicesParams): __Observable<Array<SmartIrrigationDeviceDto>> {
    return this.SmartIrrigationGetNodeDevicesResponse(params).pipe(
      __map(_r => _r.body as Array<SmartIrrigationDeviceDto>)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddNodeDeviceParams` containing the following parameters:
   *
   * - `device`:
   *
   * - `customerId`:
   */
  SmartIrrigationAddNodeDeviceResponse(params: SmartIrrigationService.SmartIrrigationAddNodeDeviceParams): __Observable<__StrictHttpResponse<SmartIrrigationDeviceDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.device;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/AddNodeDevice/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationDeviceDto>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationAddNodeDeviceParams` containing the following parameters:
   *
   * - `device`:
   *
   * - `customerId`:
   */
  SmartIrrigationAddNodeDevice(params: SmartIrrigationService.SmartIrrigationAddNodeDeviceParams): __Observable<SmartIrrigationDeviceDto> {
    return this.SmartIrrigationAddNodeDeviceResponse(params).pipe(
      __map(_r => _r.body as SmartIrrigationDeviceDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateNodeDeviceParams` containing the following parameters:
   *
   * - `device`:
   *
   * - `customerId`:
   */
  SmartIrrigationUpdateNodeDeviceResponse(params: SmartIrrigationService.SmartIrrigationUpdateNodeDeviceParams): __Observable<__StrictHttpResponse<SmartIrrigationDeviceDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.device;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SmartIrrigation/UpdateNodeDevice/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationDeviceDto>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationUpdateNodeDeviceParams` containing the following parameters:
   *
   * - `device`:
   *
   * - `customerId`:
   */
  SmartIrrigationUpdateNodeDevice(params: SmartIrrigationService.SmartIrrigationUpdateNodeDeviceParams): __Observable<SmartIrrigationDeviceDto> {
    return this.SmartIrrigationUpdateNodeDeviceResponse(params).pipe(
      __map(_r => _r.body as SmartIrrigationDeviceDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationLinkDeviceToNodeParams` containing the following parameters:
   *
   * - `link`:
   *
   * - `customerId`:
   */
  SmartIrrigationLinkDeviceToNodeResponse(params: SmartIrrigationService.SmartIrrigationLinkDeviceToNodeParams): __Observable<__StrictHttpResponse<SmartIrrigationDeviceDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.link;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SmartIrrigation/LinkDeviceToNode/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SmartIrrigationDeviceDto>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationLinkDeviceToNodeParams` containing the following parameters:
   *
   * - `link`:
   *
   * - `customerId`:
   */
  SmartIrrigationLinkDeviceToNode(params: SmartIrrigationService.SmartIrrigationLinkDeviceToNodeParams): __Observable<SmartIrrigationDeviceDto> {
    return this.SmartIrrigationLinkDeviceToNodeResponse(params).pipe(
      __map(_r => _r.body as SmartIrrigationDeviceDto)
    );
  }

  /**
   * @param params The `SmartIrrigationService.SmartIrrigationDeleteNodeDeviceParams` containing the following parameters:
   *
   * - `deviceId`:
   *
   * - `customerId`:
   */
  SmartIrrigationDeleteNodeDeviceResponse(params: SmartIrrigationService.SmartIrrigationDeleteNodeDeviceParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/SmartIrrigation/DeleteNodeDevice/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.deviceId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SmartIrrigationService.SmartIrrigationDeleteNodeDeviceParams` containing the following parameters:
   *
   * - `deviceId`:
   *
   * - `customerId`:
   */
  SmartIrrigationDeleteNodeDevice(params: SmartIrrigationService.SmartIrrigationDeleteNodeDeviceParams): __Observable<Blob> {
    return this.SmartIrrigationDeleteNodeDeviceResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  SmartIrrigationGetDeviceTypesResponse(): __Observable<__StrictHttpResponse<Array<SmartIrrigationDeviceTypeDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetDeviceTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SmartIrrigationDeviceTypeDto>>;
      })
    );
  }  SmartIrrigationGetDeviceTypes(): __Observable<Array<SmartIrrigationDeviceTypeDto>> {
    return this.SmartIrrigationGetDeviceTypesResponse().pipe(
      __map(_r => _r.body as Array<SmartIrrigationDeviceTypeDto>)
    );
  }

  /**
   * @param customerId undefined
   */
  SmartIrrigationGetAssociatableUsersResponse(customerId: number): __Observable<__StrictHttpResponse<Array<User>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SmartIrrigation/GetAssociatableUsers/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<User>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SmartIrrigationGetAssociatableUsers(customerId: number): __Observable<Array<User>> {
    return this.SmartIrrigationGetAssociatableUsersResponse(customerId).pipe(
      __map(_r => _r.body as Array<User>)
    );
  }
}

module SmartIrrigationService {

  /**
   * Parameters for SmartIrrigationSnoozeAlarm
   */
  export interface SmartIrrigationSnoozeAlarmParams {
    customerId: number;
    alarmId: number;
  }

  /**
   * Parameters for SmartIrrigationGetAutomatedSchedule
   */
  export interface SmartIrrigationGetAutomatedScheduleParams {
    deviceEui: string;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationClearAutomatedSchedule
   */
  export interface SmartIrrigationClearAutomatedScheduleParams {
    deviceEui: string;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationAddWeeklySchedule
   */
  export interface SmartIrrigationAddWeeklyScheduleParams {
    customerId: number;
    Type?: 0 | 1 | 2;
    StartTime?: string;
    Name?: null | string;
    Id?: number;
    EndTime?: string;
    Enabled?: boolean;
    Description?: null | string;
    DayOfWeek?: null | 0 | 1 | 2 | 3 | 4 | 5 | 6;
    ControllerDeviceEui?: null | string;
  }

  /**
   * Parameters for SmartIrrigationUpdateWeeklySchedule
   */
  export interface SmartIrrigationUpdateWeeklyScheduleParams {
    customerId: number;
    Type?: 0 | 1 | 2;
    StartTime?: string;
    Name?: null | string;
    Id?: number;
    EndTime?: string;
    Enabled?: boolean;
    Description?: null | string;
    DayOfWeek?: null | 0 | 1 | 2 | 3 | 4 | 5 | 6;
    ControllerDeviceEui?: null | string;
  }

  /**
   * Parameters for SmartIrrigationAddManualSchedule
   */
  export interface SmartIrrigationAddManualScheduleParams {
    customerId: number;
    timeZoneOffsetMinutes?: number;
    Type?: 0 | 1 | 2;
    StartTime?: string;
    Name?: null | string;
    Id?: number;
    EndTime?: string;
    Enabled?: boolean;
    Description?: null | string;
    ControllerDeviceEui?: null | string;
  }

  /**
   * Parameters for SmartIrrigationUpdateManualSchedule
   */
  export interface SmartIrrigationUpdateManualScheduleParams {
    customerId: number;
    Type?: 0 | 1 | 2;
    StartTime?: string;
    Name?: null | string;
    Id?: number;
    EndTime?: string;
    Enabled?: boolean;
    Description?: null | string;
    ControllerDeviceEui?: null | string;
  }

  /**
   * Parameters for SmartIrrigationAddAutomatedSchedule
   */
  export interface SmartIrrigationAddAutomatedScheduleParams {
    customerId: number;
    Type?: 0 | 1 | 2;
    StartTime?: null | string;
    SoilMoistureProbeDeviceEui?: null | string;
    Name?: null | string;
    IrrigationCutoff?: number;
    Id?: number;
    EndTime?: null | string;
    Enabled?: boolean;
    Description?: null | string;
    DayOfWeek?: null | 0 | 1 | 2 | 3 | 4 | 5 | 6;
    ControllerDeviceEui?: null | string;
  }

  /**
   * Parameters for SmartIrrigationUpdateAutomatedSchedule
   */
  export interface SmartIrrigationUpdateAutomatedScheduleParams {
    customerId: number;
    Type?: 0 | 1 | 2;
    StartTime?: null | string;
    SoilMoistureProbeDeviceEui?: null | string;
    Name?: null | string;
    IrrigationCutoff?: number;
    Id?: number;
    EndTime?: null | string;
    Enabled?: boolean;
    Description?: null | string;
    DayOfWeek?: null | 0 | 1 | 2 | 3 | 4 | 5 | 6;
    ControllerDeviceEui?: null | string;
  }

  /**
   * Parameters for SmartIrrigationDeleteSchedule
   */
  export interface SmartIrrigationDeleteScheduleParams {
    scheduleId: number;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationGetNode
   */
  export interface SmartIrrigationGetNodeParams {
    nodeId: number;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationAddNode
   */
  export interface SmartIrrigationAddNodeParams {
    node: SmartIrrigationNodeCreateDto;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationUpdateNode
   */
  export interface SmartIrrigationUpdateNodeParams {
    node: SmartIrrigationNodeUpdateDto;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationDeleteNode
   */
  export interface SmartIrrigationDeleteNodeParams {
    nodeId: number;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationGetNodeUsers
   */
  export interface SmartIrrigationGetNodeUsersParams {
    nodeId: number;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationAddNodeUser
   */
  export interface SmartIrrigationAddNodeUserParams {
    nodeUser: SmartIrrigationNodeUserCreateDto;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationUpdateNodeUser
   */
  export interface SmartIrrigationUpdateNodeUserParams {
    nodeUser: SmartIrrigationNodeUserUpdateDto;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationDeleteNodeUser
   */
  export interface SmartIrrigationDeleteNodeUserParams {
    nodeUserId: number;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationGetNodeDevices
   */
  export interface SmartIrrigationGetNodeDevicesParams {
    nodeId: number;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationAddNodeDevice
   */
  export interface SmartIrrigationAddNodeDeviceParams {
    device: SmartIrrigationDeviceCreateDto;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationUpdateNodeDevice
   */
  export interface SmartIrrigationUpdateNodeDeviceParams {
    device: SmartIrrigationDeviceUpdateDto;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationLinkDeviceToNode
   */
  export interface SmartIrrigationLinkDeviceToNodeParams {
    link: SmartIrrigationDeviceLinkDto;
    customerId: number;
  }

  /**
   * Parameters for SmartIrrigationDeleteNodeDevice
   */
  export interface SmartIrrigationDeleteNodeDeviceParams {
    deviceId: number;
    customerId: number;
  }
}

export { SmartIrrigationService }
